document.querySelector('.nav-btn').addEventListener('click', function() {
    document.querySelector('.nav').classList.toggle('nav--open');
    this.innerHTML = this.innerHTML === 'Close' ? 'Menu' : 'Close';
    });